import React from 'react';
import { useSelector } from 'react-redux';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { useBeneficiarySettings } from '../hooks/useBeneficiarySettings';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { BeneficiarySettings } from '../model/epi-props';
import { CreateBeneficiaryForm } from './create-beneficiary-form';


interface Props {
	settingsId: string;
}
export function BeneficiaryCreate(props: Props) {

	const { settingsId } = props;
	const loaded = useBeneficiarySettings(settingsId);
	const settings = useSelector<TcsmStates, BeneficiarySettings>(state => state?.epiProps?.beneficiarySettingsState?.epiContent);
	if (!loaded) {
		return <LoadingCircle />;
	}

	return (
		<CreateBeneficiaryForm settings={settings} />
	);
}